import initialState from 'src/state'
import * as types from 'src/actions/types'

export default (state = initialState.shouldShowMobileCategory, action) =>
  action.type === types.SET_SHOULD_SHOW_MOBILE_CATEGORY ? Boolean(action.payload) : state
